import React, { Component } from "react";

import {
  CButton,
  CFormGroup,
  CLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CSelect
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";

class HelpdeskCategoryModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: props.category,
      categories: [{ id: 1, name: "Carregando..." }]
    };
  }

  async componentDidMount() {
    const res = await axios.post(
      `${URL.api}helpdesk/category/list`,
      {},
      { headers: { authorization: `Bearer ${this.props.user.token}` } }
    );

    this.setState({ categories: res.data.data });
  }

  changeHelpdesk() {
    const obj = {
      category_id: this.state.type
    };

    axios
      .post(`${URL.api}helpdesk/helpdesk/update/${this.props.helpdesk}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.props.onClose();
      })
      .catch(error => {
        toastr.error("Falha", "Não foi possível criar a solicitação!");
      });
  }

  render() {
    return (
      <CModal
        show={this.props.show}
        onClose={() => this.props.onClose()}
        centered
        size="sm"
        color="white modal-helpdesk"
        closeOnBackdrop={false}
      >
        <CModalBody>
          <CFormGroup>
            <CLabel className="font-weight-bold">Tipo de solicitação</CLabel>
            <CSelect
              value={this.state.type}
              onChange={e => this.setState({ type: e.target.value })}
            >
              {this.state.categories.map(category => (
                <option value={category.id}>{category.name}</option>
              ))}
            </CSelect>
          </CFormGroup>
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            className="mr-2"
            onClick={() => this.changeHelpdesk()}
          >
            Salvar
          </CButton>
          <CButton color="secondary" onClick={() => this.props.onClose()}>
            Cancelar
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  note: state.note
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HelpdeskCategoryModal);
